import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  TerminalCatalogQuery,
  TerminalCatalogRepository,
} from '@app/domain/ports/tpv/terminal-catalog.repository';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { TerminalDto } from '@app/data/dtos/tpv/terminal.dto';
import { mapTerminal } from '@app/data/mappers/tpv/terminal.mapper';
import { toTpvPage } from '@app/data/mappers/tpv/tpv-page.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope } from '@app/data/tpv/tpv-envelope';
import { toHttpParams } from './tpv-http.util';

/**
 * `GET /api/v1/tpv/terminals/` como catálogo (feature 151). Sin comercio el back
 * responde con el alcance del usuario (PR #43): `toHttpParams` omite el
 * `undefined`, así que no viaja ningún parámetro de comercio. Con comercio va
 * `id_merchant` (el que ya funciona en la pantalla Terminales; Q2 abierta sobre
 * `merchant_ids`). Paginado (Q1 abierta sobre `get_all`): si el back confirma
 * otra forma, el cambio queda en este archivo.
 */
@Injectable()
export class TerminalCatalogRemoteDataSource extends TerminalCatalogRepository {
  private readonly http = inject(HttpClient);

  override getCatalogPage(query: TerminalCatalogQuery): Observable<TpvPage<TpvTerminal>> {
    const { page, limit } = query;
    const params = toHttpParams({ id_merchant: query.merchantId, page, limit });
    return this.http
      .get<TpvEnvelope<unknown>>(tpvUrl('terminals/'), { params })
      .pipe(map((raw) => toTpvPage<TerminalDto, TpvTerminal>(raw, mapTerminal, { page, limit })));
  }
}
